import React, { useRef, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import pictQRcode from "../../images/pictQRcode.jpg"; 
import sponsor from "../../images/sponsor.png"; 

const HomeFooterSection = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    const handleQRClick = () => {
        // window.location.href = "https://sunnytseng.com";
        window.open('https://sunnytseng.com', '_blank');
    };

    const handleClick = () => {
        window.open('https://buymeacoffee.com/sunnytseng', '_blank');
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // console.log("元素進入視窗！");
                        setIsVisible(true);
                    } else {
                        // console.log("元素離開視窗！");
                        setIsVisible(false);
                    }
                });
            },
            {
                threshold: 0
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <StyledSec ref={sectionRef} className={isVisible ? "animate" : ""}>
            <StyledPictQRcode 
                src={pictQRcode} 
                alt="QR code" 
                onClick={handleQRClick} 
            />
            <FooterList>
                <li style={{ '--i': 1 }} className={isVisible ? "animate" : ""}>
                    <StyledLink href="https://buymeacoffee.com/sunnytseng" target="_blank">Buy me a coffee !! ☕</StyledLink>
                </li>
                <li style={{ '--i': 2 }} className={isVisible ? "animate" : ""}>
                    © 2024 Sunny Tseng. All Rights Reserved.
                </li>
            </FooterList>
            {/* <StyledPictQRcode 
                src={sponsor} 
                alt="" 
                onClick={handleClick} 
            /> */}
        </StyledSec>
    );
}

export default HomeFooterSection;

// 定義針對 <section> 的淡入動畫
const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

// 定義 QR Code 的持續晃動動畫
const qrCodeFloat = keyframes`
    0%, 100% {
        transform: translateY(0); /* 初始位置 */
    }
    50% {
        transform: translateY(-10px); /* 上移 10px */
    }
`;

const StyledSec = styled.section`
    background-color: var(--app-banner-bg, #171921);
    height: 500px;
    width: 100%; 
    display: flex;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    color: var(--app-banner-text, #ffffff);
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;

    &.animate {
        opacity: 1;
        transform: translateY(0);
        animation: ${fadeIn} 1s ease-in-out forwards; /* 使用動畫觸發淡入 */
    }

    /* 加入 RWD 支援 */
    @media (max-width: 768px) {
        flex-direction: column; /* 在小螢幕時垂直排列 */
        height: auto;
        padding: 20px;
    }
`;

const StyledPictQRcode = styled.img`
    border-radius: 10px;
    height: 70px;
    margin: 30px;
    animation: ${qrCodeFloat} 2s ease-in-out infinite; /* 持續上下晃動 */

    &:hover {
        transform: scale(1.2);
        cursor: pointer;
        box-shadow: 0 0 15px 5px rgba(240, 165, 0, 0.7);
    }

    @media (max-width: 768px) {
        order: 2;
        margin-right: 33px;
    }
`;

const FooterList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    li {
        color: var(--app-banner-text, #ffffff);
        font-size: 18px;
        margin-bottom: 10px;
        text-align: center;
        line-height: 1.5;
        opacity: 0;
        transform: translateY(20px);
        transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
    }

    li.animate {
        opacity: 1;
        transform: translateY(0);
        animation: ${fadeIn} 1s ease-in-out forwards;
        animation-delay: calc(var(--i) * 0.2s);
    }

    li:hover {
        color: gray;
    }

    @media (max-width: 768px) {
        order: 1;
    }
`;

const StyledLink = styled.a`
    color: var(--app-banner-text, #ffffff);
    text-decoration: none;
    &:hover {
        text-decoration: underline;
        color: gray;
        box-shadow: 0 0 100px 5px rgba(240, 165, 0, 0.7);
    }
`;
